import { createAndMergeCanvasEntity } from "./canvas.js";
import { createAndMergeMemoEntity } from "./memo.js";
import { createAndMergeRelationshipEntity } from "./relationship.js";
import { createAndMergeTableEntity } from "./table.js";
//#region ../erd-editor-schema/dist/v2/parser/index.js
function parser(source) {
	const json = source;
	return {
		canvas: createAndMergeCanvasEntity(json.canvas),
		table: createAndMergeTableEntity(json.table),
		relationship: createAndMergeRelationshipEntity(json.relationship),
		memo: createAndMergeMemoEntity(json.memo)
	};
}
//#endregion
export { parser };
